import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createElektronikCalculatorForm(): FormGroup<ElektronikCalculatorFormModel> {
  return new FormGroup<ElektronikCalculatorFormModel>({
    initialPrice: new FormControl<null | number>(null, [
      Validators.required
    ])
  });
}

export interface ElektronikCalculatorFormModel {
  initialPrice: FormControl<null | number>;
}
